<template>
    <div>
        <ul v-if="props.linkedTasks.length">
            <li v-for="task in props.linkedTasks" :key="task">
                <a href="#" @click.prevent="viewDetails(task.id)">{{ task.title }}  <span v-if="task.archived_at">[Archived]</span></a>
            </li>
        </ul>
        <span v-else>No associated tasks found...</span>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
    linkedTasks: {
        type: Array,
    },
});

const router = useRouter();

const viewDetails = (taskId) => {
    const routeData = router.resolve({ name: 'TaskDetails', params: { id: taskId } });
    window.open(routeData.href, '_blank');
};
</script>
